import { Component, Input, ElementRef, Renderer2, ViewEncapsulation, OnChanges } from '@angular/core';

@Component({
  selector: 'ms-preload-image',
  templateUrl: './preload-image.component.html',
  styleUrls: [
    './preload-image.component.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class PreloadImageComponent implements OnChanges {

  _src = '';
  _ratio?: { w: number, h: number };

  constructor(
    private _elementRef: ElementRef,
    private _renderer: Renderer2
  ) {}

  @Input() set src(val: string) {
    this._src = (val !== undefined && val !== null) ? val : '';
  }

  @Input() set ratio(ratio: { w: number, h: number }) {
    this._ratio = ratio;
  }

  ngOnChanges() {
    if (this._ratio) {
      const ratio_height = (this._ratio.h / this._ratio.w * 100) + '%';
      // Conserve aspect ratio (see: http://stackoverflow.com/a/10441480/1116959)
      this._renderer.setStyle(this._elementRef.nativeElement, 'padding', '0px 0px ' + ratio_height + ' 0px');
    }
    this._update();
  }

  _update() {
    this._loaded(false);
  }

  _loaded(isLoaded: boolean, event?) {
    if (isLoaded) {
      this._renderer.addClass(this._elementRef.nativeElement, 'img-loaded');
    } else {
      this._renderer.removeClass(this._elementRef.nativeElement, 'img-loaded');
    }

    // TODO: Ionic BAD workaround --> Reference https://github.com/ionic-team/ionic/issues/16947
    // ion-img does not support onError event
    if (event) {
      let img = event.srcElement.shadowRoot.children[1];
      img.onerror = (e) => { console.log(e) }
    }
  }
}